<template>
  <div
    :class="['language-selector', { mobile: isMobile }]"
    ref="languageSelector"
  >
    <div class="selected-language" @click="toggleDropdown">
      <span class="flag">{{ selectedFlag }}</span>
    </div>
    <ul v-if="dropdownOpen" class="language-dropdown">
      <li
        v-for="(lang, key) in languages"
        :key="key"
        :class="{ selected: language === key }"
        @click="changeLanguage(key)"
      >
        <span class="flag me-2">{{ lang.flag }}</span>
        {{ lang.name }}
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ref, computed, defineProps, onMounted, onBeforeUnmount } from 'vue'
import { useI18n } from 'vue-i18n'
import { language, languageManuallySelected } from '@/plugins/i18n'

defineProps({
  isMobile: {
    type: Boolean,
    default: false,
  },
})

const languageSelector = ref(null)
const { t } = useI18n()
const dropdownOpen = ref(false)
const i18n = useI18n()

const languages = computed(() => ({
  pt_BR: { name: t('message.portugueseBR'), flag: '🇧🇷' },
  pt_PT: { name: t('message.portuguesePT'), flag: '🇵🇹' },
  en: { name: t('message.english'), flag: '🇺🇸' },
  es: { name: t('message.spanish'), flag: '🇪🇸' },
}))

const selectedFlag = computed(() => {
  return languages.value[language.value]?.flag
})

function toggleDropdown() {
  dropdownOpen.value = !dropdownOpen.value
}

function changeLanguage(lang) {
  language.value = lang
  i18n.locale.value = lang
  dropdownOpen.value = false
  languageManuallySelected.value = true
}

function handleClickOutside(event) {
  if (
    dropdownOpen.value &&
    languageSelector.value &&
    !languageSelector.value.contains(event.target)
  ) {
    // ...fechamos o dropdown.
    dropdownOpen.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>

<style scoped>
.language-selector {
  position: relative;
}

.selected {
  background-color: #e0e0e0;
}

.selected:hover {
  background-color: #d0d0d0;
}

.selected-language {
  cursor: pointer;
  display: flex;
  align-items: center;
  border-radius: 5px;
}

.flag {
  font-size: 1.5rem;
  margin-bottom: 1px;
}

.language-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
  list-style: none;
  padding: 0;
  margin: 5px 0 0;
  z-index: 10;
  width: 210px;
}

.language-dropdown li {
  padding: 10px 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.language-dropdown li:hover {
  background-color: #f0f0f0;
}

.language-selector.mobile .language-dropdown {
  /* Adjust dropdown position for mobile if needed */
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
}

.language-selector.mobile .selected-language {
  justify-content: center;
}
</style>
